import { render, staticRenderFns } from "./Boxlist.vue?vue&type=template&id=bd807a96"
import script from "./Boxlist.vue?vue&type=script&lang=js"
export * from "./Boxlist.vue?vue&type=script&lang=js"
import style0 from "./Boxlist.vue?vue&type=style&index=0&id=bd807a96&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports